var map = {
	"./1.png": "1c6d",
	"./2.png": "97de",
	"./3.png": "a821",
	"./background.png": "63b9",
	"./button_reverse-timeline_01.png": "e7c1",
	"./button_reverse-timeline_02.png": "06a4",
	"./button_revert-to-full-timeline.png": "5433",
	"./button_zoomin.png": "c409",
	"./button_zoomout.png": "917d",
	"./circle_active.png": "74e3",
	"./circle_active_large.png": "b703",
	"./classroom_bg_watercolor.png": "c225",
	"./dots.png": "0d04",
	"./gamestage.png": "3bf9",
	"./geo-icon.png": "1ed8",
	"./icon_breadcrumb_home.png": "4d94",
	"./icon_breadcrumb_home_yellow.png": "7c22",
	"./icon_download.png": "3253",
	"./icon_glossary-book.png": "55d2",
	"./icon_magnifying-glass.png": "9bcc",
	"./icon_print.png": "276d",
	"./info_location_pin.png": "08c3",
	"./location_pin.png": "848c",
	"./map_arrow (2).png": "55d3",
	"./map_arrow.png": "fdfe",
	"./map_pin_red.png": "1c44",
	"./map_pin_yellow.png": "59e0",
	"./search-tab_close_arrow.png": "af3e",
	"./timeline_active.png": "f28e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e67f";